import RelativeSumGameAnswer from "./RelativeSumGameAnswer";
import {isNullOrUndefined} from "../../../../services/Validator";

export default function RelativeSumGameAnsweringBlock({currentQuestion, userSign, userAnswer}) {
    // Used in RelativeSumGameContent to display both question and answer
    // blocks

    // BUILD
    if (isNullOrUndefined(currentQuestion))
        return null
    const tokens = tokenizeMathExpression(currentQuestion);
    return (
        <div className="w-full flex justify-between items-center text-[40px] font-medium">
            {tokens.map((token, index) => (
                <span key={index}
                      className={renderTokenStyle(token)}>
                    {token}
                </span>
            ))}
            <RelativeSumGameAnswer
                sign={userSign}
                answer={userAnswer} />
        </div>
    );

    // METHODS
    // ---- UI : Tokenize question for style treatment
    function tokenizeMathExpression(expr) {
        return expr.trim().split(/\s+/);
    }

    // ---- UI : Render span style
    function renderTokenStyle(token) {
        return ["+", "-", "×", "x", "÷"].includes(token)
            ? "text-timerBlue font-normal text-[40px]"
            : token === "="
                ? "text-greyLight9"
                : "text-white"
    }
}